export const SET_SERVIDOR = "setServidor";
export const ADD_DISPOSITIVO = "addDispositivo";
export const ADD_DISPOSITIVO_ARMAZENAMENTO = "addDispositivoArmazenamento";
export const RESET_STATE = "resetModuleState";

export const SET_USUARIO = "setUsuario";
export const SET_TOKEN = "setToken";
export const SET_UNIDADES = "setUnidades";
export const DELETE_USUARIO = "deleteUsuario";
export const DELETE_TOKEN = "deleteToken";
